// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamEditor {
  color: #334155;
}
.teamEditor__intro {
  margin-bottom: 18px;
}
.teamEditor__intro strong {
  color: #142033;
  font-size: 22px;
  font-weight: 800;
}
.teamEditor__intro p {
  margin: 4px 0 0;
  color: #69778a;
  font-size: 14px;
}
.teamEditor__card {
  overflow: hidden;
  border: 1px solid #dbe3ec;
  border-radius: 14px;
  background: #fff;
}
.teamEditor__card .row {
  padding: 24px 24px 0;
}
.teamEditor .row {
  margin: 0;
}
.teamEditor .col-md-12 {
  padding: 0;
}
.teamEditor__form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.teamEditor__form > label {
  margin: 10px 0 0;
  color: #334155;
  font-size: 12px;
  font-weight: 750;
}
.teamEditor__form > label em {
  color: #c9364b;
  font-style: normal;
}
.teamEditor__form .form-control {
  min-height: 42px;
  margin: 0 !important;
  padding: 9px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #142033;
  font-size: 13px;
  box-shadow: none;
}
.teamEditor__form textarea.form-control {
  min-height: 96px;
  resize: vertical;
}
.teamEditor__form .form-control:focus {
  border-color: #368fca;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);
}
.teamEditor__autocomplete {
  margin: 0 !important;
}
.teamEditor__autocomplete input {
  min-height: 42px !important;
  border-color: #cbd5e1 !important;
  border-radius: 9px !important;
  font-size: 13px !important;
}
.teamEditor__error {
  margin-top: -2px;
  padding: 0;
  color: #b42338;
  font-size: 11px;
}
.teamEditor__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}
.teamEditor__chips button {
  display: inline-flex;
  height: 38px;
  align-items: center;
  gap: 7px;
  padding: 0 15px;
  border: 1.5px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 650;
}
.teamEditor__chips button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.teamEditor__emptyChoice,
.teamEditor__hint {
  color: #69778a;
  font-size: 12px;
}
.teamEditor__divider {
  height: 1px;
  margin: 12px 0 10px;
  background: #e5eaf0;
}
.teamEditor__houseSwitch {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0 0 8px !important;
  padding: 16px 18px;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
}
.teamEditor__homeIcon {
  display: inline-flex;
  color: #227ebd;
}
.teamEditor__houseSwitch > div {
  display: flex;
  flex: 1;
  flex-direction: column;
}
.teamEditor__houseSwitch strong {
  color: #142033;
  font-size: 14px;
}
.teamEditor__houseSwitch small {
  margin-top: 2px;
  color: #69778a;
  font-size: 12px;
}
.teamEditor__houseSwitch > button {
  width: 46px;
  height: 27px;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: #cbd5e1;
}
.teamEditor__houseSwitch > button.is-active {
  background: #227ebd;
}
.teamEditor__houseSwitch > button span {
  display: block;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s;
}
.teamEditor__houseSwitch > button.is-active span {
  transform: translateX(19px);
}
.teamEditor__houseChips {
  margin-top: 2px;
  padding: 13px 14px;
  border: 1px solid #dbe3ec;
  border-radius: 11px;
  background: #f8fafc;
}
.teamEditor__houseChips legend {
  margin-bottom: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 750;
}
.teamEditor__houseChips .people-chipFilter__chip,
.teamEditor__houseChips .people-chipFilter__more {
  min-height: 31px;
  padding: 4px 10px;
  font-size: 12px;
}
.teamEditor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin: 20px -24px 0;
  padding: 14px 24px;
  border-top: 1px solid #e5eaf0;
}
.teamEditor__save {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.teamEditor__cancel,
.teamEditor__save {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
.teamEditor__cancel {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.teamEditor__save {
  border: 1px solid #227ebd;
  background: #227ebd;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/TeamsAndEvents/Teams/SchoolTeamForm/SchoolTeamForm.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".teamEditor {\n  color: #334155;\n}\n.teamEditor__intro {\n  margin-bottom: 18px;\n}\n.teamEditor__intro strong {\n  color: #142033;\n  font-size: 22px;\n  font-weight: 800;\n}\n.teamEditor__intro p {\n  margin: 4px 0 0;\n  color: #69778a;\n  font-size: 14px;\n}\n.teamEditor__card {\n  overflow: hidden;\n  border: 1px solid #dbe3ec;\n  border-radius: 14px;\n  background: #fff;\n}\n.teamEditor__card .row {\n  padding: 24px 24px 0;\n}\n.teamEditor .row {\n  margin: 0;\n}\n.teamEditor .col-md-12 {\n  padding: 0;\n}\n.teamEditor__form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.teamEditor__form > label {\n  margin: 10px 0 0;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 750;\n}\n.teamEditor__form > label em {\n  color: #c9364b;\n  font-style: normal;\n}\n.teamEditor__form .form-control {\n  min-height: 42px;\n  margin: 0 !important;\n  padding: 9px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #142033;\n  font-size: 13px;\n  box-shadow: none;\n}\n.teamEditor__form textarea.form-control {\n  min-height: 96px;\n  resize: vertical;\n}\n.teamEditor__form .form-control:focus {\n  border-color: #368fca;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);\n}\n.teamEditor__autocomplete {\n  margin: 0 !important;\n}\n.teamEditor__autocomplete input {\n  min-height: 42px !important;\n  border-color: #cbd5e1 !important;\n  border-radius: 9px !important;\n  font-size: 13px !important;\n}\n.teamEditor__error {\n  margin-top: -2px;\n  padding: 0;\n  color: #b42338;\n  font-size: 11px;\n}\n.teamEditor__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n}\n.teamEditor__chips button {\n  display: inline-flex;\n  height: 38px;\n  align-items: center;\n  gap: 7px;\n  padding: 0 15px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 650;\n}\n.teamEditor__chips button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.teamEditor__emptyChoice,\n.teamEditor__hint {\n  color: #69778a;\n  font-size: 12px;\n}\n.teamEditor__divider {\n  height: 1px;\n  margin: 12px 0 10px;\n  background: #e5eaf0;\n}\n.teamEditor__houseSwitch {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin: 0 0 8px !important;\n  padding: 16px 18px;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #fff;\n}\n.teamEditor__homeIcon {\n  display: inline-flex;\n  color: #227ebd;\n}\n.teamEditor__houseSwitch > div {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.teamEditor__houseSwitch strong {\n  color: #142033;\n  font-size: 14px;\n}\n.teamEditor__houseSwitch small {\n  margin-top: 2px;\n  color: #69778a;\n  font-size: 12px;\n}\n.teamEditor__houseSwitch > button {\n  width: 46px;\n  height: 27px;\n  padding: 3px;\n  border: 0;\n  border-radius: 999px;\n  background: #cbd5e1;\n}\n.teamEditor__houseSwitch > button.is-active {\n  background: #227ebd;\n}\n.teamEditor__houseSwitch > button span {\n  display: block;\n  width: 21px;\n  height: 21px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n  transition: transform 0.15s;\n}\n.teamEditor__houseSwitch > button.is-active span {\n  transform: translateX(19px);\n}\n.teamEditor__houseChips {\n  margin-top: 2px;\n  padding: 13px 14px;\n  border: 1px solid #dbe3ec;\n  border-radius: 11px;\n  background: #f8fafc;\n}\n.teamEditor__houseChips legend {\n  margin-bottom: 8px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 750;\n}\n.teamEditor__houseChips .people-chipFilter__chip,\n.teamEditor__houseChips .people-chipFilter__more {\n  min-height: 31px;\n  padding: 4px 10px;\n  font-size: 12px;\n}\n.teamEditor__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin: 20px -24px 0;\n  padding: 14px 24px;\n  border-top: 1px solid #e5eaf0;\n}\n.teamEditor__save {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.teamEditor__cancel,\n.teamEditor__save {\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamEditor__cancel {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.teamEditor__save {\n  border: 1px solid #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
